export default {
  react: {
    topic: 'ReactJs Tutorial',
    chapters: [
      {
        chapter: 'Introduction',
      },
      { chapter: 'Components' },
      { chapter: 'Props' },
      { chapter: 'States' },
      { chapter: 'UseEffect' },
      { chapter: 'Project 1 (Quiz App)' },
    ],
  },

  js: {
    topic: 'JavaScript Tutorial',
    chapters: [
      {
        chapter: 'Introduction',
        pages: [
          {
            title: 'Well here you go',
            content: `<pre>Table of Contents

   1.  Introduction . . . . . . . . . . . . . . . . . . . . . . . . .  4
     1.1.  Background . . . . . . . . . . . . . . . . . . . . . . . .  4
     1.2.  Protocol Overview  . . . . . . . . . . . . . . . . . . . .  5
     1.3.  Opening Handshake  . . . . . . . . . . . . . . . . . . . .  6
     1.4.  Closing Handshake  . . . . . . . . . . . . . . . . . . . .  9</pre>`,
          },
        ],
      },
      { chapter: 'Execution' },
      { chapter: 'Syntax' },
      { chapter: 'Variables' },
      { chapter: 'Operators' },
      { chapter: 'Conditionals' },
      { chapter: 'DOM API' },
      { chapter: 'DataTypes' },
      {
        chapter: 'Array Methods',
        sections: [
          {
            title: 'Push',
            pages: [
              { title: 'Page Title', content: 'Page Content' },
              {
                title: 'Page Title 2',
                content: `Page Content 2
              <ul>
              <li>
              Hello</li>
              <li>How are you</li></ul>
                `,
              },
            ],
          },
          {
            title: 'Pop',
            pages: [{ title: 'Page Title', content: 'Page Content' }],
          },
          { title: 'Unshift' },
          { title: 'Shift' },
          { title: 'Splice' },
          { title: 'Slice' },
          { title: 'Concat' },
          { title: 'ForEach' },
          { title: 'Sort' },
          { title: 'Map' },
          { title: 'Filter' },
          { title: 'Reduce' },
        ],
      },
    ],
  },

  webDev: {
    topic: 'WebDev Stuffs',
    chapters: [
      {
        chapter: 'Prisma Migrate',
      },
      { chapter: 'WebSockets' },
      { chapter: 'KeystoneJs' },
      { chapter: 'GraphQl' },
    ],
  },
};
